// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3s9Iy","consentsList":"PatientConsents_consentsList__DVesc","consentsListEmpty":"PatientConsents_consentsListEmpty__3gAH7"};